import { useEffect, useRef } from "react";

/**
 * Returns the previous value of the provided value.
 *
 * @typeParam T - The type of the value.
 * @param value - The current value.
 * @returns The previous value.
 */
function usePrevious<T>(value: T): T | undefined {
  const reference = useRef<T>();
  useEffect(() => {
    reference.current = value;
  }, [value]);
  return reference.current;
}

export default usePrevious;
